import React, { useState, useEffect, Fragment } from 'react';
import { connect } from 'react-redux';
import { Card, CardBody, CardTitle, Button, Badge } from 'reactstrap';
import { Colxx } from '../../../../../components/common/CustomBootstrap';
import { NavLink } from 'react-router-dom';
import moment from 'moment';
import { gAPI_Tickets_list, gAPI_Tickets_By_Id } from '../../../../../constants/APIs';
import 'react-perfect-scrollbar/dist/css/styles.css';
import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';

const QuickReplyList = ({
    startDate,
    endDate,
    offset,
    items,
    isLoading,
    data,
    activeIndex,
    handleContactClick
}) => {
    return (<Fragment></Fragment>)
}
export default QuickReplyList;